import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuest = loadable(() => import(/* webpackChunkName: "content/guest" */ './Guest'));
